import ActiveMotionLanding from "./Page/active-motion-comprehensive";
function App() {
    return (
        <div>
            <ActiveMotionLanding />
        </div>
    );
}

export default App;
